module.exports = __webpack_public_path__ + "img/square_logo.f0aaec5a.png";